<template>
  <div class="tab-history-wrap section-space--mt_80">
    <div class="row">
       <div class="col-lg-7">
        <section id="google_map_5" class="ht-service-box--three mb-40">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d76418.64304702416!2d28.944356091633093!3d41.051598483705014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caba9cff3081d7%3A0x81b4ccecd163e562!2sBarkod%20Yaz%C4%B1l%C4%B1mevi%20San%20ve%20Tic.%20Ltd.%20Sti!5e0!3m2!1str!2str!4v1582904347701!5m2!1str!2str"
            width="100%"
            height="100%"
            frameborder="0"
            style="border:0"
          ></iframe>
        </section>
      </div>
       <div class="col-lg-5">
        <div class="tab-content-inner">
        <ul class="ht-service-box--three mb-40">
            <div>
              <h6>{{$t("sirketunvani")}}</h6>
              <p>Barkod Yazılımevi San. ve Tic. Ltd. Şti</p>
            </div>
            <div>
              <h6>{{$t('kurulusyili')}}</h6>
              <p>1996</p>
            </div>

            <div>
              <h6>{{$t('adres')}}</h6>
              <p>Perpa Ticaret Merkezi B Blok Kat:9 No :1454 Şişli , İstanbul / Türkiye</p>
            </div>

            <div>
              <h6>{{$t('telefon')}}</h6>
              <p>
                <a href="tel:+905322412008">+90-532-241-20-08</a>
              </p>
            </div>
            <div>
              <h6>{{$t('gsm')}}</h6>
              <p>
                <a href="tel:+905322412008">+90-532-241-20-08</a>
              </p>
            </div>

            <div>
              <h6>{{$t('email')}}</h6>
              <p>
                <a href="mailto:info@barkodyazilimevi.com.tr">info@barkodyazilimevi.com.tr</a>
              </p>
            </div>
            
            <div>
              <h6>{{$t('vkn')}}</h6>
              <p>1420592791</p>
              <p>{{$t('efaturamukellefi')}}</p>
            </div>
            <ul class="list ht-social-networks solid-rounded-icon">
              <li class="item">
                <a
                  href="https://www.facebook.com/barkodyazilim"
                  target="_blank"
                  class="social-link"
                >
                  <i class="fab fa-facebook social-link-icon"></i>
                </a>
              </li>
              <li class="item">
                <a href="https://www.twitter.com/barkodyazilim" target="_blank" class="social-link">
                  <i class="fab fa-twitter social-link-icon"></i>
                </a>
              </li>
              <li class="item">
                <a
                  href="https://www.instagram.com/barkodyazilim"
                  target="_blank"
                  class="social-link"
                >
                  <i class="fab fa-instagram social-link-icon"></i>
                </a>
              </li>
            </ul>
        </ul>
        </div>
      </div>  
    </div>
  </div>
</template>

<script>
export default {
  name: "TabContentFour"
};
</script>

